





































import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Card from '@/components/default/Card.vue';
import Popup from '@/components/default/Popup.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';
import $ from 'jquery';
import { ProjectContactsClient, ProjectContactDto, ISecurityConfig } from '@/data/web-api-client';
import AddContactDialog from '@/modules/CRM/components/AddContactDialog.vue';
import AddOrUpdateContactDialog from '@/modules/CRM/components/AddOrUpdateContactDialog.vue';
import AddOrUpdateCompanyDialog from '@/modules/CRM/components/AddOrUpdateCompanyDialog.vue';
import ProjectContactLookupPopup from '@/modules/projects/components/contacts/ProjectContactLookupPopup.vue';
import AuthenticationService from '@/auth/AuthenticationService';
import { SecurityConfig } from '@/installationConfig';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
    Popup,
    Datagrid,
    ProjectContactLookupPopup,
    AddContactDialog,
    AddOrUpdateContactDialog,
    AddOrUpdateCompanyDialog,
  },
})
export default class ProjectContactCard extends Vue {
  @Prop({ required: true })
  projectId!: string;

  @Prop({ required: false, default: false })
  public disabled!: boolean;

  selectedContact: ProjectContactDto | null = null;
  contacts: ProjectContactDto[] = [];
  loading: boolean = false;

  client: ProjectContactsClient = new ProjectContactsClient(undefined, this.$axios);
  authService: AuthenticationService = new AuthenticationService();
  securityConfig: ISecurityConfig = SecurityConfig;

  saving: boolean = false;
  showLookupPopup: boolean = false;

  createContact() {
    (this.$refs.AddContactDialog as AddContactDialog).open();
  }

  created() {
    this.loadData();
  }

  openLookup() {
    this.selectedContact = null;
    (this.$refs.ProjectContactLookupPopup as ProjectContactLookupPopup).open();
  }

  editContactSettings(e: any) {
    if (this.disabled) {
      return;
    }

    if (e.row && !e.row.isEditing && e.column && e.column.type !== 'buttons' && e.column.type !== 'selection') {
      this.selectedContact = e.row.data;
      (this.$refs.ProjectContactLookupPopup as ProjectContactLookupPopup).open();
    }
  }

  async loadData() {
    try {
      this.loading = true;
      this.contacts = await this.client.getContacts(this.projectId);
    } catch (err) {
      notificationService.showErrorMessage('Er is iets misgelopen tijdens het inladen van de data');
    } finally {
      this.loading = false;
    }
  }

  addOrUpdateContact(contact: ProjectContactDto) {
    const index = this.contacts.findIndex((o) => o.contact!.id === contact.contact!.id);
    if (index !== -1) {
      this.contacts[index] = contact;
    } else {
      this.contacts.push(contact);
    }

    ((this.$refs.grid as Datagrid).$refs.projectContactsTable as any).instance.refresh();
  }

  deleteRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      try {
        await new ProjectContactsClient(undefined, self.$axios).removeContact(self.projectId, e.data.contact.id);
        notificationService.saved();
        resolve(false);
      } catch (err) {
        notificationService.failedToSave();
        resolve(true);
      }
    });
  }

  get isQualityGuard() {
    return this.authService.isInAnyRole([this.securityConfig.qualityGuardOneSkinGroup || '']);
  }

  get selectedContactId() {
    if (this.selectedContact && this.selectedContact.contact) {
      return this.selectedContact.contact!.id;
    }

    return '';
  }

  get isSelectedContactSubcontractor() {
    if (this.selectedContact && this.selectedContact.contact && this.selectedContact.contact.type === 'Subcontractor') {
      return true;
    }

    return false;
  }

  get columns() {
    const self = this;
    console.log(this.isQualityGuard);

    return [
      {
        caption: 'Naam',
        dataField: 'contact.displayName',
        cellTemplate: (cellElement: any, cellInfo: any) => {
          let icon = '';
          switch (cellInfo.data.contact.type) {
            case 'Subcontractor':
              icon = 'fa-hard-hat';
              break;
            case 'Company':
              icon = 'fa-building';
              break;
            case 'Contact':
              icon = 'fa-user';
              break;
            case 'employee':
              icon = 'fa-user';
              break;
          }
          return $(cellElement).append(`<i class='fas ${icon}'></i> ${cellInfo.data.contact.displayName}`);
        },
      },
      {
        caption: 'Tel.',
        dataField: 'contact.phone',
        cellTemplate: (container: any, options: any) => {
          if (options.value && options.value !== '') {
            $('<a>' + options.value + '</a>')
              .attr('href', `tel:${options.value}`)
              .attr('target', '_blank')
              .appendTo(container);
          }
        },
      },
      {
        caption: 'Email',
        dataField: 'contact.email',
      },
      {
        caption: 'Facturen',
        dataField: 'sendInvoice',
        dataType: 'boolean',
      },
      {
        caption: 'Offertes',
        dataField: 'sendQuotation',
        dataType: 'boolean',
      },
      {
        caption: 'Vorderingstaten',
        dataField: 'sendProgressStatement',
        dataType: 'boolean',
      },
      {
        caption: 'Technische fiches',
        dataField: 'sendProjectFiches',
        dataType: 'boolean',
      },
      {
        caption: 'Tags',
        dataField: 'tags',
      },
      {
        type: 'buttons',
        visible: (e: any) => {
          return !self.isQualityGuard;
        },
        buttons: [
          /*{
                        hint: 'Duplicate',
                        icon: 'fas fa-edit',
                        visible(e: any) {
                            return !e.row.isEditing;
                        },
                        onClick: ,
                    },*/
          {
            hint: 'details',
            icon: 'fas fa-eye',
            visible(e: any) {
              return !self.isQualityGuard && !e.row.isEditing && !self.disabled;
            },
            onClick: (e: any) => {
              const data = e.row.data as ProjectContactDto;
              switch (data.contact!.type) {
                case 'Contact':
                  this.$router.push(`/contacts/${data.contact!.id}`);
                  break;
                case 'Company':
                  this.$router.push(`/companies/${data.contact!.id}`);
                  break;
                case 'Subcontractor':
                  this.$router.push(`/subcontractors/${data.contact!.id}`);
                  break;
                case 'Employee':
                  this.$router.push(`/employees/${data.contact!.id}`);
                  break;
              }
            },
          },
          {
            hint: 'details',
            icon: 'fas fa-edit',
            visible(e: any) {
              return !self.isQualityGuard && !e.row.isEditing && !self.disabled;
            },
            onClick: (e: any) => {
              const data = e.row.data as ProjectContactDto;
              switch (data.contact!.type) {
                case 'Contact':
                  this.selectedContact = data;
                  (this.$refs.AddOrUpdateContactDialog as AddOrUpdateContactDialog).open();
                  break;
                case 'Company':
                  this.selectedContact = data;
                  (this.$refs.AddOrUpdateCompanyDialog as AddOrUpdateCompanyDialog).open();
                  break;
                case 'Subcontractor':
                  this.selectedContact = data;
                  (this.$refs.AddOrUpdateCompanyDialog as AddOrUpdateCompanyDialog).open();
                  break;
                case 'Employee':
                  this.$router.push(`/employees/${data.contact!.id}`);
                  break;
              }
            },
          },
          {
            name: 'delete',
            visible(e: any) {
              return !self.isQualityGuard && !e.row.isEditing && !self.disabled;
            },
          },
        ],
      },
    ];
  }
}
